import { render, staticRenderFns } from "./ButtonCard.vue?vue&type=template&id=57344988&scoped=true"
import script from "./ButtonCard.vue?vue&type=script&lang=js"
export * from "./ButtonCard.vue?vue&type=script&lang=js"
import style0 from "./ButtonCard.vue?vue&type=style&index=0&id=57344988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57344988",
  null
  
)

export default component.exports